module.exports = __webpack_public_path__ + "assets/successSparkleD-d7be12.svg";